import React from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import diagram from '../../../assets/image-empty1.PNG';
import Button from '../../Butten/Button';
import Pinkbtn from '../../Butten/Pinkbtn';

const Diagram = ({ field, index, saveDiagrams, onDeleteDiagrams }) => {
  const uploadImages = id => {
    const imgWindow = document.querySelector(`#${id}`);
    imgWindow.click();
  };
  return (
    <>
      <div
        className="m-0 p-0 rounded-b-xl"
        style={{ backgroundColor: '#eceff4' }}
      >
        <div className="diagrams">
          <p className="font-medium pt-3 pb-1 px-5">diagram</p>
          <div className="images-diagram flex flex-wrap w-[47]">
            {/* diagram1 */}
            {field.diagrams.map((_dia, _index) => (
              <>
                <div className="image  flex  my-2 mx-4">
                  <img
                    className="h-14 w-14  rounded-lg mt-2"
                    src={_dia.src}
                    alt=""
                  />
                  <IoMdCloseCircleOutline
                    onClick={() => onDeleteDiagrams(index, _index)}
                    size={10}
                    cursor={'pointer'}
                  />
                </div>
              </>
            ))}
          </div>
        </div>
        <div className="btns flex justify-between mt-4 w-[44vw]">
          <div className="dot" style={{ color: '#eceff4' }}>
            .
          </div>
          <div className="btn flex">
            <input
              id={`diagrams-${field.id}`}
              onChange={e => saveDiagrams(e, index, field.id)}
              hidden
              type="file"
              multiple
            />
            {/* <Button btntext="cancle" />
            <Button btntext="save" /> */}
            <button
              className="flex place-content-center bg-white rounded-md text-sm 
                              h-6 w-16 m-1"
              style={{
                border: '1px solid #fe104d',
                backgroundColor: '#fe104d',
                color: 'white',
              }}
              onClick={() => uploadImages(`diagrams-${field.id}`)}
            >
              Upload
            </button>
            {/* <Pinkbtn pbtntext="upload" /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Diagram;
